export default (theme) => ({
    root: {
        width: '100%',

        '&.dana-chat-comment--clickable': {
            cursor: 'pointer',
            '&:hover': {
                '& .dana-chat-comment-text-container': {
                    backgroundColor: theme.colors.actionMinor[50],
                },
            },
        },

        '&.dana-chat-comment--copied': {
            '& .dana-chat-comment-data': {
                '& .dana-chat-comment-text-container': {
                    '& .dana-chat-comment-copy__icon': {
                        '& svg path': {
                            fill: theme.colors.actionMajor[500],
                        },
                    },
                },
            },
        },

        '& .dana-chat-comment-data': {
            display: 'flex',
            gap: 20,
            alignItems: 'flex-end',

            '& .dana-chat-comment-avatar': {
                width: 30,
                height: 30,
                flexShrink: 0,

                '& > *': {
                    width: 30,
                    height: 30,
                },
            },

            '& .dana-chat-comment-text-container': {
                width: 'calc(100% - (20px + 30px))',
                minHeight: 44,
                border: `1px solid ${theme.colors.grey[200]}`,
                borderRadius: 8,
                boxSizing: 'border-box',
                padding: 12,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,

                '&:only-child': {
                    width: '100%',
                },

                '&.dana-chat-comment-user': {
                    backgroundColor: theme.colors.background.utility025,
                    border: '1px solid transparent',
                },

                '& .dana-chat-comment-actions': {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 8,

                    '& .dana-chat-comment-copy__icon, & .dana-chat-comment-email__icon, & .dana-chat-comment-thumb__icon':
                        {
                            width: 16,
                            height: 16,
                            justifyContent: 'center',
                            alignItems: 'center',

                            '& svg': {
                                width: 16,

                                '& path': {
                                    fill: theme.colors.actionMinor[500],
                                },
                            },

                            '&:hover': {
                                cursor: 'pointer',

                                '& svg path': {
                                    fill: theme.colors.actionMinor[600],
                                },
                            },
                        },

                    '& .dana-chat-comment-thumb__icon': {
                        '&.dana-chat-comment__voted': {
                            pointerEvents: 'none',
                            '& svg path': {
                                fill: theme.colors.actionMajor[500],
                            },
                        },
                    },

                    '& .dana-chat-comment-date': {},
                },
            },
        },

        '& .dana-chat-comment-error': {
            padding: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 8,

            '& button': {
                ...theme.typography.body,
            },
        },
    },
    chatText: {
        wordWrap: 'break-word',
        '& strong': {
            fontWeight: 500,
        },
        '& em': {
            fontStyle: 'italic',
        },
        '& li, & ol, & ul': {
            listStyle: 'initial',
        },
        '& hr': {
            border: 'none',
            borderTop: `1px solid ${theme.colors.grey[100]}`,
        },
    },
    chatTextLoading: {
        '& *': {
            ...theme.typography.caption,
            color: theme.colors.utility.textSecondary,
        },
    },
    chatTextEllipsis: {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        // Fix for nested content lists
        '& ul, & ol': {
            display: 'block',
            paddingLeft: 0,
        },
    },
});
